const ID_API_TOKEN = 'id_api_token';
const LOGGED_IN_PANEL = 'logged_in_panel';
const LOGGED_IN_COMP_EMAIL = 'logged_in_comp_email';
const LOGGED_IN_ADMIN_EMAIL = 'logged_in_admin_email';
const LOGGED_IN_COMP_PASS = 'logged_in_comp_pass';
const COMP_REMEMBER_ME = 'comp_remember_me';
const ADMIN_REMEMBER_ME = 'admin_remember_me';
const LOGGED_IN_ADMIN_PASS = 'logged_in_admin_pass';
const SIDEBAR = 'sidebar';
const CURRENT_TAB = 'current_tab';
const CURRENT_PAGE = 'current_page';
const PER_PAGE = 'per_page';
const PROFILE_IMAGE = 'profile_image';
const CURR_PLAN_ID = 'curr_plan_id';
const AMOUNT = 'amount';
const PRICE_ID = 'price_id';
const PLAN_ID  = 'plan_id';
const PERIOD   = 'period';
const CURRENCY = 'currency';
const PRICINGLISTNAME = 'pricingListName';
const MONTHLY = 'monthly';
const USER_PROFILE = 'user_profile'
const MONTHLY_PLAN_DATA = 'monthly_plan_data';
const YEARLY_PLAN_DATA = 'yearly_plan_data';
const INVESTMENT_DATA= 'investment_data';
const SUB_CATEGORY_DATA= 'sub_category_data';
const SUB_CATEGORY_NAME= 'sub_category_name';




export const getToken = () => {
    return window.localStorage.getItem(ID_API_TOKEN);
};

export const getMonthlyPlan = () => {
    return window.localStorage.getItem(MONTHLY_PLAN_DATA)
};

export const getInvestmentData = () => {
    return window.localStorage.getItem(INVESTMENT_DATA)
};

export const getSubCategoryData = () => {
    return window.localStorage.getItem(SUB_CATEGORY_DATA)
};

export const getSubCategoryName = () => {
    return window.localStorage.getItem(SUB_CATEGORY_NAME)
};

export const getYearlyPlan = () => {
    return window.localStorage.getItem(YEARLY_PLAN_DATA)
};

export const getUserProfile = () => {
    return window.localStorage.getItem(USER_PROFILE)
};

export const getAmount = () => {
    return window.localStorage.getItem(AMOUNT)
};

export const getPrice = () => {
    return window.localStorage.getItem(PRICE_ID)
};

export const getPlan = () => {
    return window.localStorage.getItem(PLAN_ID)
};

export const getCurrency = () => {
    return window.localStorage.getItem(CURRENCY)
};
export const getPricingListName = () => {
    return window.localStorage.getItem(PRICINGLISTNAME)
};
export const getMonthly = () => {
    return window.localStorage.getItem(MONTHLY)
};

export const getPeriod = () => {
    return window.localStorage.getItem(PERIOD)
};

export const getTLoggedInPanel = () => {
    return window.localStorage.getItem(LOGGED_IN_PANEL)
};

export const getCompanyEmail = () => {
    return window.localStorage.getItem(LOGGED_IN_COMP_EMAIL)
}

export const getAdminEmail = () => {
    return window.localStorage.getItem(LOGGED_IN_ADMIN_EMAIL)
}

export const getCompanyPass = () => {
    return window.localStorage.getItem(LOGGED_IN_COMP_PASS)
}

export const getCurrentTab = () => {
    return window.localStorage.getItem(CURRENT_TAB)
}

export const getCurrentPage = () => {
    return window.localStorage.getItem(CURRENT_PAGE)
}

export const getPerPage = () => {
    return window.localStorage.getItem(PER_PAGE)
}

export const getAdminPass = () => {
    return window.localStorage.getItem(LOGGED_IN_ADMIN_PASS)
}

export const getCompanyRememberMe = () => {
    return window.localStorage.getItem(COMP_REMEMBER_ME)
}

export const getAdminRememberMe = token => {
    return window.localStorage.getItem(ADMIN_REMEMBER_ME,token)
}

export const getSidebar = () => {
    return window.localStorage.getItem(SIDEBAR)
}

export const getProfileImage = () => {
    return window.localStorage.getItem(PROFILE_IMAGE)
}

export const getCurrentPlan = () => {
    return window.localStorage.getItem(CURR_PLAN_ID)
}

export const setCompanyEmail = token => {
    window.localStorage.setItem(LOGGED_IN_COMP_EMAIL, token)
}

export const setAdminEmail = token => {
    window.localStorage.setItem(LOGGED_IN_ADMIN_EMAIL, token)
}

export const setCompanyPass = token => {
    window.localStorage.setItem(LOGGED_IN_COMP_PASS, token)
}

export const setCurrentTab = token => {
    window.localStorage.setItem(CURRENT_TAB, token)
}

export const setCurrentPage = token => {
    window.localStorage.setItem(CURRENT_PAGE, token)
}

export const setPerPage = token => {
    window.localStorage.setItem(PER_PAGE, token)
}

export const setAdminPass = token => {
    window.localStorage.setItem(LOGGED_IN_ADMIN_PASS, token)
}

export const setCompanyRememberMe = token => {
    window.localStorage.setItem(COMP_REMEMBER_ME, token)
}

export const setAdminRememberMe = token => {
    window.localStorage.setItem(ADMIN_REMEMBER_ME, token)
}

export const setToken = token => {
    window.localStorage.setItem(ID_API_TOKEN, token, token);
};

export const setTLoggedInPanel = panel => {
    window.localStorage.setItem(LOGGED_IN_PANEL, panel);
};

export const setSidebar = sidebar => {
    window.localStorage.setItem(SIDEBAR, sidebar);
};

export const setProfileImage = profileImage => {
    window.localStorage.setItem(PROFILE_IMAGE, profileImage);
};

export const setCurrentPlan = currentPlanId => {
    window.localStorage.setItem(CURR_PLAN_ID, currentPlanId);
};

export const setMonthly = monthly => {
    window.localStorage.setItem(MONTHLY, monthly);
};

export const setAmount = amount => {
    window.localStorage.setItem(AMOUNT, amount);
};

export const setPrice = priceId => {
    window.localStorage.setItem(PRICE_ID, priceId);
};

export const setPlan = planId => {
    window.localStorage.setItem(PLAN_ID, planId);
};

export const setPeriod = period => {
    window.localStorage.setItem(PERIOD, period);
};

export const setCurrency= currency => {
    window.localStorage.setItem(CURRENCY, currency);
};

export const setPricingListName = pricingListingName => {
    window.localStorage.setItem(PRICINGLISTNAME, pricingListingName);
};
export const setUserProfile = setUserProfile => {
    window.localStorage.setItem(USER_PROFILE, setUserProfile);
};

export const setMonthlyPlan = setMonthlyPlan => {
    window.localStorage.setItem(MONTHLY_PLAN_DATA, setMonthlyPlan);
};

export const setYearlyPlan = setYearlyPlan => {
    window.localStorage.setItem(YEARLY_PLAN_DATA, setYearlyPlan);
};

export const setInvestmentData = setInvestment => {
    window.localStorage.setItem(INVESTMENT_DATA, setInvestment);
};

export const setSubCategoryData = setSubcategory => {
    window.localStorage.setItem(SUB_CATEGORY_DATA, setSubcategory);
};

export const setSubCategoryName = setSubcategoryName => {
    window.localStorage.setItem(SUB_CATEGORY_NAME, setSubcategoryName);
};

export const unsetToken = () => {
    window.localStorage.removeItem(ID_API_TOKEN);
    window.localStorage.removeItem(LOGGED_IN_PANEL);
    window.localStorage.removeItem(SIDEBAR);
    window.localStorage.removeItem(CURRENT_PAGE);
    window.localStorage.removeItem(CURRENT_TAB );
    window.localStorage.removeItem(PER_PAGE);
};

export default  { 
                    getToken, 
                    getTLoggedInPanel, 
                    setToken, 
                    setTLoggedInPanel, 
                    unsetToken, 
                    getCompanyEmail, 
                    getAdminEmail, 
                    getCompanyPass, 
                    getAdminPass, 
                    setCompanyEmail, 
                    setAdminEmail, 
                    setCompanyPass, 
                    setAdminPass, 
                    setAdminRememberMe, 
                    setCompanyRememberMe, 
                    getCompanyRememberMe, 
                    getAdminRememberMe, 
                    getSidebar, 
                    setSidebar, 
                    getCurrentTab, 
                    getCurrentPage, 
                    setCurrentPage, 
                    setCurrentTab, 
                    getPerPage, 
                    setPerPage,
                    setProfileImage, 
                    getProfileImage ,
                    setCurrentPlan,
                    getCurrentPlan,
                    setMonthly,
                    getMonthly,
                    setAmount,
                    getAmount,
                    setPrice,
                    getPrice,
                    setPlan,
                    getPlan,
                    setCurrency,
                    getCurrency,
                    setPeriod,
                    getPeriod,
                    setPricingListName,
                    getPricingListName,
                    setUserProfile,
                    getUserProfile,
                    setMonthlyPlan,
                    getMonthlyPlan,
                    setYearlyPlan,
                    getYearlyPlan,
                    setInvestmentData,
                    getInvestmentData,
                    setSubCategoryData,
                    getSubCategoryData,
                    setSubCategoryName,
                    getSubCategoryName,
                }
